<template>
  <div class="addon-product-container" :class="isRecommended ? 'recommended':''">
      <div class="product-image-container" :class="(canAddMore == false && this.currentQty == 0) ? 'disabled' :'available'">
        <img v-if="mainBadge != null && mainBadge != 'Trending'" src="https://cdn.shopify.com/s/files/1/1363/8433/files/diverse_flag.svg?v=1754931860" class="main-badge"/>
        <p v-else-if="mainBadge == 'Trending'" class="trending-badge">Trending</p>
        <span v-if="secondaryBadge != null" class="secondary-badge">{{secondaryBadge}}</span>
        <img  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" @click="loadModal()" width="270" height="270" class="main-image" loading="lazy" :src="product | getProductImage" >
        <img loading="lazy" @click="loadModal()" v-if="product.images.length > 1" :src="product.images[1].src" class="hover-image" />
        <div v-if="canAddMore == false && this.currentQty == 0" class="limit-alert">{{limitMessage}}</div>
        <img v-if="isBrandable" class="logo-placeholder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/logo_grey_2.svg?v=1725379927" alt="logo here"/>
        <div v-if="isBrandable" class="edit-float">
          <p>Add your logo</p>
          <div class="edit-btn">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634" alt="edit"/>
          </div>
        </div>
        <button :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button white border">{{ addCopy }}</button>
      </div>
      <button :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button white border">{{ addCopy }}</button>
      <div :class="!canAddMore ? 'no-more' : ''" class="quantity-container" v-show="currentQty > 0">
          <button @click="updateProductQuantity(false)">-</button>
          <p>{{currentQty}} per box</p>
          <button v-tooltip="{content: limitMessage, container: false}" @click="updateProductQuantity(true)">+</button>
      </div>
      <div class="product-price-container">
        <p class="product-title">{{product.title}}</p>
        <span v-if="hasComparePrice != null" class="discount-price">{{hasComparePrice | moneySaleFormat}}</span>
        <span class="price">{{productPrice | moneySaleFormat}}</span>
      </div>
  </div>
</template>
<script>
export default {
    props: {
        product: Object,
        cartProducts: Array,
        maxCapacity: Number,
        currentCapacity: Number,
        boxQty: Number,
        productLimit: Number,
        addCopy: String,
        isRecommended: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        isHovering: false,
      }
    },
    computed:{
        productPrice(){
            return this.product.variants.find(x => x.price != "").price
        },
        hasComparePrice(){
          return this.product.variants.find(x => x.price != "").compare_at_price
        },
        currentQty(){
          if(this.cartProducts){
            var product = this.cartProducts.find(x => x.id == this.product.id);
            if(product)
              return product.quantity
          }
          return 0
        },
        canAddMore(){
          if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
            return false
          if((this.boxQty * (this.currentQty + 1)) > this.maxInventory)
            return false
          if(this.currentQty >= this.productLimit)
            return false

          return true
        },
        maxInventory(){
          return Math.max(...this.product.variants.map(x => x.inventory_quantity))
        },
        limitMessage(){
          if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
            return 'Your Box is too full!';
          if((this.boxQty * (this.currentQty + 1)) > this.maxInventory)
            return 'Not enough inventory';
          if(this.currentQty >= this.productLimit)
            return 'Item limit per box'

          return ''
        },
        secondaryBadge(){
          //Check badges in the following order. 
          // Minimum: has qtymin tag
          // Almost gone: Invetory < 20
          // Best seller: has "Filter_Badges_Best Seller" tag
          // New: has been published for less that 60 days

          let qtyMin = this.product.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND")) 
          if(qtyMin){
            qtyMin = qtyMin.split("_");
            qtyMin = qtyMin[qtyMin.length - 1];

            return `Minimum: ${qtyMin}`;
          }

          var inventory = this.product.variants[0].inventory_quantity;
          if(inventory < 20)
            return "Less than 20";
      
          var badge = this.product.tags.find(y => y.includes("Filter_Badges"));
          if(badge){
              badge = badge.replace("Filter_","").split("_")
              return badge[1];
          }

          return null
        },
        mainBadge(){
          if(this.product.tags.some(x => x.toLowerCase().includes("builder_reco")))
            return "Trending"

          var tags =  this.product.tags.filter(y => y.includes("Tag_"));
          if(tags.length > 0){
            tags = tags.map((x) => {
              var currentTag = x.replace("Tag_","").replace("Tag_","");
              return currentTag;
            })

            return tags[0];
          }

          var ethos = this.product.tags.filter(y => y.includes("Filter_Ethos"));
          if(ethos.length > 0){
            ethos = ethos.map((x) => {
              var currentEthos = x.replace("Filter_","").split("_")
              return currentEthos[1]
            })

            return ethos[0];
          }

          return null
          
        },
        isPride(){
          let prideTag = this.product.tags.find(x => x.includes("Pride Donation"))
          if(prideTag){
            return true;
          }
          return false
        },
        shouldHover(){
          if(this.canAddMore == false && this.currentQty > 0 && this.isHovering == true){
            return true;
          }
          return false;
        },
        hasVariants(){
          return this.product.variants.length > 1 && this.product.variants.every(x => !x.sku || (x.sku && !x.sku.toLowerCase().includes("ondemand")));
        },
        isCustom(){
          return this.product.tags.some(x => x.includes("Customizable"))
        },
        isBrandable(){
          return this.product.tags.some(y => y.includes("Brandable Swag"));
        },
        hasMinQty(){
          return this.product.tags.some(x => x.includes("QTYMIN"))
        },
        isOnDemand(){
          return this.product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        badgeExtraClass(){
          switch(this.mainBadge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        }
    },
    methods:{
      isMobile() {
        return window.innerWidth < 768;
      },
      updateProductQuantity(increment){
        if(this.hasVariants || this.isCustom || this.hasMinQty){
          this.loadModal();
          return;
        }
        if(increment){
          if(this.canAddMore)
            this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: (this.currentQty + 1)});
        }
        else{
          this.$store.commit('updateSelectedAddonProductsNew', {product: this.product,quantity: (this.currentQty - 1)});
        }
      },
      loadModal(){
        if(this.canAddMore || this.currentQty > 0)
          this.$emit("loadmodal", this.product);
      },
      dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      },
      setButtonHover(state){
        this.isHovering = state;
      }
    },
}
</script>

<style scoped>
.addon-product-container{
  width: 100%;
}


.product-image-container{
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.5rem;
}

.product-image-container .main-image {
  width: 100%;
  background-color: #F6F6F6;
  cursor: pointer;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.product-image-container .hover-image{
  background-color: #f6f6f6;
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  -webkit-transition: all .35s ease-in-out;
  transition: all .35s ease-in-out;
  opacity: 0;
}

.product-image-container:hover .hover-image{
  opacity: 1;
}

.product-image-container.disabled img{
  opacity: 0.4;
}

.limit-alert{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: white;
  width: 100%;
  position: absolute;
  bottom: 40%;
  font-size: 1.2vw;
  color: black;
  font-weight: bold;
}

.happybox-button{
  width: 100%;
}

.product-image-container.available:hover .happybox-button{
  bottom: 5%;
  z-index: 1;
}

.quantity-container{
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-around;
  z-index: 2;
}

.quantity-container button{
  display: flex;
  font-size: 2vw;
  width: 15%;
  line-height: 1.15;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #F3EEFA;
  box-shadow: 0px 1px 2px #1f293714;
  border-radius: 4px;
}

.quantity-container button:hover{
  background-color: #faf7fe
}

.quantity-container button.has-tooltip{
  opacity: 0.6;
}

.quantity-container p{
  background: #FFFFFF;
  border: 1px solid #F3EEFA;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1%;
  width: 50%;
  font-size: 1vw;
}

.product-title{
  font-weight: 700;
  font-size: 1.1vw;
  line-height: 1.5;
}

.product-price-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1vw;
  line-height: 1.43;
  padding-bottom: 0.5rem;
  justify-content: space-between;
  padding-top: 0.5rem;
}

.product-price-container .price{
  color: #3F3D60;
}

.product-price-container .discount-price{
  color: red;
  text-decoration: line-through;
  padding-right: 2%;
}

.main-badge{
  position: absolute;
  top: 2%;
  left: 2%;
  padding: 1% 3%;
  width: 35%;
  z-index: 1;
}

.trending-badge{
  background-color: #ccccff;
  position: absolute;
  top: 2%;
  left: 2%;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
}

.pride-badge{
  position: absolute;
  bottom: 3%;
  right: 3%;
  width: 75%;
}

.secondary-badge{
  position: absolute;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
  color: #5981d9;
  bottom: 2%;
  right: 2%;
  background-color: #eff4fe;
}

.main-badge.pink{
  background-color: #fbdaff;
}

.main-badge.green{
  background-color: #d8efdf;
}

.main-badge.yellow{
  background-color: #ffe7c7;
}

.main-badge.dgreen{
  background-color: #a9ffbd;
}

.main-badge.lyellow{
  background-color: #fffcdd;
}

.logo-placeholder{
  position: absolute;
  width: 15%;
  top: 45%;
  left: 42.5%;
}

.edit-float{
  position: absolute;
  top: 5%;
  right: 5%;
  display: flex;
  align-items: center;
  z-index: 2;
  cursor: pointer;
  justify-content: space-between;
  width: auto;
}

.edit-float p{
  font-size: 1vw;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  background-color: #5cffc0;
  padding: 0.1rem 1rem;
  flex-shrink: 0;
  border-radius: 8px;
  position: relative;
  right: -7%;
}

.edit-btn{
  border-radius: 50%;
  background-color: #5cffc0;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 25px;
  flex-shrink: 0;
  z-index: 0;
}

.edit-btn img{
  width: 100%;
}

.product-image-container > .happybox-button{
  display: none;
}

@media screen and (min-width: 767px){
  .addon-product-container{
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .recommended > .happybox-button{
    display: none;
  }

  .recommended .product-image-container > .happybox-button{
    position: absolute;
    width: 90%;
    bottom: -30%;
    margin: unset;
    transition: all 0.5s ease-in-out;
    left: 5%;
    padding: 2%;
    display: block;
  }

  .recommended .product-image-container:hover > .happybox-button{
    bottom: 10%;
    z-index: 1;
  }

}


@media screen and (max-width: 767px){

  .recommended .product-image-container > .happybox-button{
    display: none;
  }

  .happybox-button{
    position: initial;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    margin: 3% 0%;
    width: 100%;
    padding: 2%;
  }
  .quantity-container{
    position: relative;
    margin: 4% 0%;
  }
  .quantity-container button{
    font-size: 2rem;
    line-height: 1.51;
    color: #0F0C38;
    border-radius: 50px;
    height: 3.2rem;
    width: 3.2rem;
  }

  .quantity-container p{
    font-size: 1rem;
    color: #0F0C38;
    border: unset;
  }

  .product-title{
    font-size: 0.9rem;
  }

  .product-price-container{
    font-size: 1rem;
    align-items: flex-start;
    padding-bottom: 0.5rem;
  }

  .main-badge{
    top: 2%;
    font-size: 0.8rem;
  }

  .secondary-badge{
    font-size: 1rem;
  }

  .limit-alert{
    font-size: 3.5vw;
  }

  .quantity-container button .tooltip{
    display: none;
  }

  .quantity-container .no-more .tooltip{
    display: inherit;
  }

  .edit-float p{
    font-size: 3vw;
  }

  .trending-badge{
    font-size: 3vw;
  }
}

</style>